
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-details",
      function () {
        return require("private-next-pages/product-details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-details"])
      });
    }
  